import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './BookingStatusModal.css';

const ICONS = {
  success: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
  error: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
};

// Replaces a plain toast for anything a rider needs to actually register —
// a booking confirmation (tours + lessons, free or paid) or a hard rejection
// (e.g. "you already have a booking for that date"). A toast disappears on
// its own and is easy to miss; this stays until dismissed.
export function BookingStatusModal({ variant = 'success', title, subtitle, onClose }) {
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div className="bcm-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="bcm-panel" role="dialog" aria-modal="true" aria-labelledby="bcm-title">
        <div className={`bcm-icon${variant === 'error' ? ' bcm-icon--error' : ''}`}>
          {ICONS[variant] || ICONS.success}
        </div>
        <h2 className="bcm-title" id="bcm-title">{title || (variant === 'error' ? "Couldn't complete booking" : "You're booked!")}</h2>
        {subtitle && <p className="bcm-sub">{subtitle}</p>}
        <button className="bcm-dismiss" onClick={onClose} autoFocus>Got it</button>
      </div>
    </div>,
    document.body
  );
}
